// JsFromRoutes CacheKey ed2395951592c9cf76e1e16710a723c5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/demo_events'),
}
